import script from "./MobileFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MobileFooter.vue?vue&type=style&index=0&id=247ee048&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247ee048"]])

export default __exports__